import useTheme from './useTheme';

export const useInvertedButton = (fields) => {
  const { isLight } = useTheme();

  const isButtonInvertedLight = fields.InvertButtonLight?.value;
  const isButtonInvertedDark = fields.InvertButtonDark?.value;

  if (isLight) {
    return isButtonInvertedLight;
  }

  return isButtonInvertedDark;
};
